export function withNextUrl(url: string, nextUrl?: string): string {
  if (!nextUrl) return url
  return `${url}?next_url=${encodeURIComponent(nextUrl)}`
}
